import React from 'react';

import { useGetEvent } from '@vlabs/api/luna-api/client';
import type { EventId } from '@vlabs/api/luna-api/model/EventId';

import {
  EventFaceDetectionSample,
  EventBodyDetectionSample,
  EventBodyAttributes,
  EventFaceAttributes,
} from '@vlabs/monokit/entities/event-details';

import st from './EventDetectionAttributes.module.sass';

interface EventDetectionAttributesProps {
  eventId: EventId;
}

function EventDetectionAttributes({
  eventId,
}: EventDetectionAttributesProps): React.JSX.Element {
  const { data: event } = useGetEvent(eventId, { target: ['face_detections', 'body_detections'] });
  const faceSampleId = event?.face_detections?.[0]?.sample_id;
  const bodySampleId = event?.body_detections?.[0]?.sample_id;
  return (
    <div className={st.Root}>
      <div className={st.FaceSection}>
        <EventFaceDetectionSample
          className={st.Sample}
          sampleId={faceSampleId ?? ''}
        />
        <EventFaceAttributes
          className={st.Attributes}
          eventId={eventId}
        />
      </div>
      {!!event?.body_detections?.length && (
        <div className={st.BodySection}>
          <EventBodyDetectionSample
            className={st.Sample}
            sampleId={bodySampleId ?? ''}
          />
          <EventBodyAttributes eventId={eventId} />
        </div>
      )}
    </div>
  );
}

export { EventDetectionAttributes };
